import React, { createContext, useContext } from 'react'

import { FieldPrefix } from '../../../../1stlog-ui/src/components/Field'

export type TProductsContextValue = {
  id: string
  children: React.ReactNode
}
const ProductsContext = createContext<TProductsContextValue | undefined>(
  undefined,
)

export default ProductsContext

export const ProductsContextProvider = (
  props: TProductsContextValue,
): React.ReactElement => {
  const { children } = props
  return (
    <FieldPrefix prefix={props.id}>
      <ProductsContext.Provider value={props}>
        {children}
      </ProductsContext.Provider>
    </FieldPrefix>
  )
}

export const useProductsContext = (): TProductsContextValue | undefined => {
  const value = useContext(ProductsContext)
  return value
}
